import React, { useState } from 'react';
import { useDeepCompareMemo } from 'use-deep-compare';
import { useHistory, useParams } from 'react-router-dom';
import useOrderPackage from '../../../../hooks/useOrderPackage';
import styles from '../../Addons/Addons.module.scss';
import IndividualPrintsBuilder from '../../../PackageBuilders/IndividualPrintsBuilder';
import routes from '../../../../routes';
import AddonSheetBuilder from '../../../PackageBuilders/AddonSheets';
import useBackgrounds from '../../../../hooks/useBackgrounds';
import usePoses from '../../../../hooks/usePoses';
import useRetouchingExtra from "../../../../hooks/useRetouchingExtra";

export default function Addons() {
  const { orderPackageId } = useParams();
  const history = useHistory();
  const [step, setStep] = useState(0);

  const { data: orderPackage } = useOrderPackage(orderPackageId);
  const { data: backgrounds } = useBackgrounds(orderPackage?.packageId);
  const { data: poses } = usePoses(orderPackage?.studentId, orderPackage?.packageId);
  const { data: retouching, isLoading: isLoadingRetouching } = useRetouchingExtra();

  const { pose, background } = useDeepCompareMemo(() => {
    if (!orderPackage) return {};

    if (orderPackage.sheets.length > 0) {
      return { pose: orderPackage.sheets[0].pose, background: orderPackage.sheets[0].background || backgrounds[0] };
    }

    if (backgrounds.length === 0 || poses.length === 0) return {};

    return { background: backgrounds[0], pose: poses[0] };
  }, [orderPackage, backgrounds, poses]);

  const redirectUrl = () => {
    if (orderPackage?.apiOption?.name?.includes('Yearbook')) return routes.confirm(orderPackageId)
    if (!retouching) return routes.confirm(orderPackageId)

    //return routes.retouching(orderPackageId);
    return routes.confirm(orderPackageId);
  }

  if (!orderPackage) return null;
  if (!backgrounds) return null;
  if (!background) return null;
  if (!pose) return null;
  if (isLoadingRetouching) return null;

  const {
    cartId,
    packageId,
    optionId,
    student: {
      schoolId,
    },
  } = orderPackage;

  return (
    <>
      <h1 className={styles.header}>Customize your Package w/ Individual Addons</h1>
      {step === 0 && (
        <IndividualPrintsBuilder
          background={background}
          isElementary={false}
          pose={pose}
          poses={poses}
          cartId={cartId}
          optionId={optionId}
          schoolId={schoolId}
          packageId={packageId}
          orderPackage={orderPackage}
          onSave={() => setStep(1)}
          onCancelProps={{ onClick: () => history.push(redirectUrl()) }}
        />
      )}
      {step === 1 && (
        <AddonSheetBuilder
          isElementary={false}
          orderPackageId={orderPackage.id}
          onSave={() => history.push(redirectUrl())}
        />
      )}
    </>
  );
}
